var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("Grid", {
        attrs: {
          selectable: "multiple",
          id: "courseAffiliate",
          data: _vm.affiliateList,
          pagination: _vm.courseAffiliatePagination,
          columns: _vm.columnOptions,
          onRequest: _vm.fetchAffiliates,
          onSelect: _vm.updateSelectedAffiliates,
          selected: _vm.selectedAffiliates
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-active_ind",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value === 1,
                      red: props.value === 0
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.value ? "Active" : "Inactive") +
                        "\n      "
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }